module.exports = __webpack_public_path__ + "img/img5.9d94ad40.svg";